import React, { useState, useEffect } from 'react';
import { FileText, CalendarDays } from 'lucide-react';
import { MemberQuickNav } from '../MemberQuickNav';
import api from '../../lib/api';

export default function MeetingMinutesPage() {
  const [minutes, setMinutes] = useState(null);

  useEffect(() => {
    api.get('/minutes').then((res) => setMinutes(res.data)).catch(() => setMinutes([]));
  }, []);

  return (
    <main className="min-h-screen bg-[#f1e3eb] pt-44 pb-20 px-4" data-testid="meeting-minutes-page">
      <div className="max-w-3xl mx-auto">
        <MemberQuickNav />
        <div className="text-center mb-10">
          <span className="text-[#bd8cae] text-sm uppercase tracking-wider font-medium">Members Only</span>
          <h1 className="font-serif text-4xl sm:text-5xl text-[#3c4a2a] mt-2">Meeting Minutes</h1>
          <p className="text-[#3c4a2a]/70 mt-3">A record of decisions and discussions from our membership meetings.</p>
        </div>

        {minutes === null ? (
          <p className="text-center text-[#3c4a2a]/50">Loading…</p>
        ) : minutes.length === 0 ? (
          <div className="text-center bg-white rounded-xl shadow-sm p-10" data-testid="minutes-empty">
            <FileText className="w-10 h-10 text-[#bd8cae] mx-auto mb-3" />
            <p className="text-[#3c4a2a]/70">No minutes have been published yet — check back after our next meeting.</p>
          </div>
        ) : (
          <div className="space-y-6">
            {minutes.map((m) => (
              <article key={m.id} data-testid={`minutes-item-${m.id}`} className="bg-white rounded-xl shadow-md border border-[#bd8cae]/20 p-6 sm:p-8">
                <div className="flex items-center gap-2 text-sm text-[#a3688f] mb-2">
                  <CalendarDays className="w-4 h-4" />
                  {new Date(`${m.meeting_date}T12:00:00`).toLocaleDateString('en-US', { weekday: 'long', month: 'long', day: 'numeric', year: 'numeric' })}
                </div>
                <h2 className="font-serif text-2xl text-[#3c4a2a] mb-4">{m.title}</h2>
                <div className="text-[#3c4a2a]/80 leading-relaxed whitespace-pre-wrap">{m.content}</div>
              </article>
            ))}
          </div>
        )}
      </div>
    </main>
  );
}
